import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES, IMAGES } from "../data/content";
import { SectionHeader, CTABand } from "./Home";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <section className="relative py-28 md:py-36 bg-[#113835] tt-grain overflow-hidden">
        <img src={IMAGES.services} alt="Modern architecture" className="absolute inset-0 w-full h-full object-cover opacity-15" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <SectionHeader
            dark
            eyebrow="Our Services"
            title="Six disciplines. One standard of certainty."
            sub="Each engagement is handled by specialists who work directly with original records — because certainty cannot be outsourced to a database."
          />
        </div>
      </section>

      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 space-y-0 divide-y divide-[#113835]/10">
          {SERVICES.map((s, idx) => (
            <div
              key={s.title}
              data-testid={`service-detail-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="grid lg:grid-cols-12 gap-8 py-16 items-start"
            >
              <div className="lg:col-span-1">
                <span className="font-accent italic text-3xl text-[#C1A74A]/70">{String(idx + 1).padStart(2, "0")}</span>
              </div>
              <div className="lg:col-span-4 flex items-start gap-5">
                <s.icon size={34} strokeWidth={1} className="text-[#1D504C] shrink-0 mt-1" />
                <h2 className="font-heading text-2xl font-medium text-[#113835]">{s.title}</h2>
              </div>
              <div className="lg:col-span-5">
                <p className="text-base font-light text-gray-600 leading-relaxed">{s.long}</p>
              </div>
              <div className="lg:col-span-2 lg:text-right">
                <Link to="/request-title-search" className="tt-link font-heading text-xs uppercase tracking-[0.16em] text-[#1D504C] inline-flex items-center gap-2 pb-1">
                  Request <ArrowRight size={14} strokeWidth={1.5} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
